import React from 'react';
import Link from 'gatsby-link'

import styles from './Quote.module.scss';

const Quote = (props) => (
<div className={styles.Quote}>
    <div className={styles.Quote__Wrapper}>
        <div className={styles.Quote__Details}>
            {
                props.image &&
                <img className="profile-image" src={props.image.file.url} alt={props.image.title} />
            }
            <h2>{props.title}</h2>
            <Link className="hoverlink c-white" to={props.link.link}>{props.link.text}</Link>
        </div>
        <div className={`${styles.Quote__Text} quote-text`}>
            <p>{props.text}</p>
        </div>
    </div>
</div>
)

export default Quote;



// WEBPACK FOOTER //
// ./src/components/Destination/Quote/index.js